import {flexRender} from "@tanstack/react-table";
import PropTypes from "prop-types";

export const TBody = ({tableInstance, addTd}) => {
    return (
        <tbody>
        {tableInstance.getRowModel().rows.map((rowEl,index) => (
            <tr key={rowEl?.id + index}>
                {rowEl.getVisibleCells().map((cellEl, index) => (
                    <td align={'left'} key={cellEl.id + index}>
                        {flexRender(
                            cellEl.column.columnDef.cell,
                            cellEl.getContext()
                        )}
                    </td>
                ))}
                {addTd && addTd(rowEl?.original)}
            </tr>
        ))}
        </tbody>
    )
}

TBody.propTypes = {
    tableInstance: PropTypes.object.isRequired,
    addTd: PropTypes.func
}